import { createApp, markRaw, type Component } from 'vue';
import AppShell from '@/AppShell.vue';
import '@/styles/main.scss';

/**
 * Создаёт и монтирует приложение для конкретной страницы MPA.
 *
 * Каждая страница — отдельный HTML-файл со своей точкой входа
 * (index.html / about.html / requirements.html). Общая оболочка
 * (шапка, мобильное меню, подвал) переиспользуется через AppShell.
 *
 * @param view    Компонент-страница (HomeView / AboutView / RequirementsView)
 * @param current Ключ текущей страницы ('home' | 'about' | 'requirements')
 *                — используется для подсветки активного пункта меню
 */
export function createPage(view: Component, current: string): void {
  // markRaw: не даём Vue делать компонент реактивным при передаче через props
  createApp(AppShell, { view: markRaw(view), current }).mount('#app');
}
